import { IonContent } from '@ionic/react';
import RecommendedProducts from '../../../features/shared/components/recommended-products/RecommendedProducts';
import DealsCarousel from '../../../../../components-library/carousel/DealsCarousel';
import useMostPopularCategory from '../../../../../hooks/menu/useMostPopularCategory';
import Header from './components/header';
import FeaturedPosts from './components/FeaturedPosts/FeaturedPosts';
import { useTranslation } from 'react-i18next';

const HomeTab = () => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Pages:Tabs:Home:HomeTab' });
  const category = useMostPopularCategory();
  const hasRecommendedProducts = !!category?.products?.length;

  return (
    <IonContent fullscreen className="space-y-md [&::part(scroll)]:bg-white [&::part(scroll)]:pb-[140px]">
      <Header />
      <DealsCarousel dealClassName="bg-white border" />
      {hasRecommendedProducts && (
        <RecommendedProducts className="px-md">
          <RecommendedProducts.Header title={t('recommended')} />
          <RecommendedProducts.Content products={category.products} />
        </RecommendedProducts>
      )}
      <FeaturedPosts className="px-md" />
    </IonContent>
  );
};

export default HomeTab;
